import {Component} from "../interface/component";
require('slick-carousel/slick/slick.min');

export class AnnouncementCarouselComponent implements Component {

    private $root:JQuery;

    constructor(elem:HTMLElement) {
        this.$root = $(elem);
    }

    init() {
        this.bindUI();
    }

    /* Slick Settings */
    private bindUI() {
        this.$root.slick({
          dots: false,
          infinite: true,
          speed: 500,
          fade: false,
          cssEase: 'linear',
          autoplay:true,
          pauseOnFocus:false,
          prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"></button>',
          nextArrow: '<button type="button" class="slick-next" aria-label="Next"></button>'
        });
    }
}
